import React, {useState} from "react";
import PropTypes from "prop-types";
import ReactImageMagnify from "react-image-magnify";

function ZoomableImage(props) {
  const {className, smallImage, largeImage, alt, title, isDisabled} = props;
  const [dimensions, setDimensions] = useState({width: 0, height: 0});
  const onLoad = ({target: img}) => {
    const multiplier = 1.2;
    setDimensions({
      width: img.naturalWidth * multiplier,
      height: img.naturalHeight * multiplier
    });
  };
  const onLoadSmallImage = ({target: img}) => {
    img.setAttribute(`title`, title);
  };
  return (
    <div className={className}>
      {
        isDisabled ? (
          <img src={smallImage} alt={alt} title={title}/>
        ) : (
          <ReactImageMagnify
            {...{
              smallImage: {
                alt,
                title,
                isFluidWidth: true,
                src: smallImage,
                onLoad: onLoadSmallImage
              },
              largeImage: {
                src: largeImage,
                width: dimensions.width,
                height: dimensions.height,
                onLoad
              },
              enlargedImagePortalId: `portal`,
              enlargedImageContainerDimensions: {
                width: `80%`,
                height: `80%`
              },
              fadeDurationInMs: 0,
              hoverDelayInMs: 0,
              hoverOffDelayInMs: 0,
              pressDuration: 100000,
              lensStyle: {
                background: `rgba(255, 255, 255, 0.5)`
              }
            }}
          />
        )
      }
    </div>
  );
}

ZoomableImage.propTypes = {
  className: PropTypes.string,
  smallImage: PropTypes.string,
  largeImage: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  isDisabled: PropTypes.bool
};

export default ZoomableImage;
